module.exports = __webpack_public_path__ + "static/media/poorwill14.117d5cef.JPG";